module.exports = __webpack_public_path__ + "img/首页.0eea744a.svg";